<template>
  <mds-row>
    <mds-col>
      <store-provider
        v-bind="$options.storeInfo"
        is-paged
      >
        <template v-slot="{ state: filterParsers }">
          <parsers-table
            :parsers="filterParsers"
          />
        </template>
      </store-provider>
    </mds-col>
  </mds-row>
</template>

<script>
import StoreProvider from '@/components/common/StoreProvider';
import ParsersTable from '@/components/collection-exchange-monitor/table/parsers/ParsersTable.vue';
import { MODULE, COMMON } from '@/constants/store.constant';

export default {
  name: 'TableSectionEM',
  components: {
    StoreProvider,
    ParsersTable,
  },
  storeInfo: {
    module: MODULE.COLLECTION_EXCHANGE_MONITOR_MODULE,
    action: COMMON.FETCH_DATA,
    getter: COMMON.GET_STATE,
  },
};
</script>
